import React, { Component } from "react";

import getRegularPlaceData from "../../lib/getRegularPlaceData";

import LocationSearchInput from "../Common/Places";
import getLocalData from "../../lib/getLocalData";
import setLocalDeliveryData from "../../lib/setLocalDeliveryData";
import getRestaurantsLink from "../../lib/getRestaurantsLink";

export default class EnterPostCode extends Component {
  state = {
    postalCode: "",
    routeName: "",
    addressLine2: "",
    flatNumber: "",
    lat: 0,
    lon: 0
  };
  handleLocationSubmit = async place => {
    const {
      postalCode,
      routeName,
      addressLine2,
      flatNumber,
      city
    } = await getRegularPlaceData(place.address);
    const lat = place.lat,
      lon = place.lng,
      isPostalCode = place.isPostalCode;
    if (postalCode && routeName && lat && lon) {
      const { slugName, route } = this.props;
      this.setState(
        {
          postalCode,
          routeName,
          addressLine2,
          flatNumber,
          lat,
          isPostalCode,
          lon
        },
        () => {
          const localData = getLocalData("deliveryDetails");
          let delivery = true;
          if (localData) {
            delivery = localData.delivery;
            localStorage.removeItem("deliveryDetails");
          }
          const addressData = {
            lat,
            lon,
            isPostalCode,
            postalCode,
            routeName,
            addressLine2,
            flatNumber,
            delivery,
            slugName,
            city
          };
          const jsonData = JSON.stringify(addressData);
          setLocalDeliveryData(jsonData, () =>
            this.handleClose(localData, postalCode, route)
          );
        }
      );
    }
  };
  handleClose = (localData, postalCode, route) => {
    const { onClose } = this.props;
    let link;
    const currentPath = location.pathname;
    if (route === "detail") {
      link = `${currentPath}?postcode=${postalCode}&time=${(localData &&
        localData.preOrder) ||
        "now"}`;
    } else {
      link = getRestaurantsLink();
    }
    onClose(link);
  };
  render() {
    const { postalCode, routeName } = this.state;

    const { onClose } = this.props;
    return (
      <div className="enter-post-code">
        <div className="modal-bg" />
        <div className="modal">
          {/* Header */}
          <div className="head-general with-back">
            <a href="javascript: void(0)" />
            <h4>Add a delivery address</h4>
            <a
              href="javascript: void(0)"
              onClick={() => onClose({ status: "close" })}
              className="close"
            >
              <icon className="icon icon-close" />
            </a>
          </div>
          {/* Header */}
          <div className="modal-body">
            <div className="promo-error white-bg">
              <p>
                To find out if the restaurant can deliver to you, enter your address.
              </p>

              <div className="d-flex align-items-center justify-content-around hide-xs">
                <div>
                  <LocationSearchInput
                    placeholder="e.g. 39 Old Town"
                    onSubmit={this.handleLocationSubmit}
                  />
                </div>
                <div>
                  <button
                    className={
                      (postalCode && routeName && "btn btn-blue") ||
                      "btn btn-gray"
                    }
                    onClick={this.handleClose}
                    disabled={!(postalCode && routeName)}
                  >
                    Submit
                  </button>
                </div>
              </div>
              <div className="visible-xs">
                <div style={{ width: "100%" }} className="visible-xs">
                  <LocationSearchInput
                    dropdownClass="relative-dropdown"
                    placeholder="e.g. 39 Old Town"
                    onSubmit={this.handleLocationSubmit}
                  />
                </div>
                <div className="use-buttons">
                  <button
                    style={{ width: "100% important!" }}
                    className={
                      (postalCode && routeName && "btn btn-blue visible-xs") ||
                      "btn btn-gray visible-xs"
                    }
                    onClick={this.handleClose}
                    disabled={!(postalCode && routeName)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
            {/* white-bg */}
          </div>
          {/* .modal-body */}
        </div>
      </div>
    );
  }
}
